import { useNavigate } from "react-router-dom";
import {
  Button,
  FormControl,
  Stack,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import { MdRefresh } from "react-icons/md";

import logo from "assets/img/logo.png";
import { login as loginRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import {
  StyledBox,
  StyledBoxContainer,
  StyledStack,
  StyledImgContainer,
} from "./Login.style";
import { Wrapper } from "components/shared/Wrapper";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import useAuth from "hooks/use-auth";
import ImgContainer from "components/shared/Image";
import { useInputValue } from "hooks/use-input-value";
import { convertNum } from "helper/convert-num";
import Captcha from "captcha-image";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function Login() {
  const navigate = useNavigate();
  const name = useInputValue("");
  const password = useInputValue("");
  const captcha = useInputValue("");
  const [randomCaptcha, setRandomCaptcha] = useState({ image: "", word: "" });
  const [toggle, setToggle] = useState({ passwordVisibility: false });

  const { request, loading, setLoading } = useHttp(true);
  const authCTX = useAuth();

  const handleChange = () =>
    setToggle({ passwordVisibility: !toggle.passwordVisibility });

  const handleSubmit = async () => {
    if (
      [name.value.trim(), password.value.trim(), captcha.value.trim()].includes(
        ""
      )
    ) {
      return Toast({ type: "empty", title: "لطفا تمام فیلد " });
    }
    if (captcha.value.trim() !== randomCaptcha.word)
      return Toast({ type: "custom", title: " کد امنیتی وارد شده اشتباه است" });

    let res = await request({
      url: loginRequest,
      values: { name: name.value, password: convertNum(password.value) },
    });

    authCTX.login(res.token);
    navigate("/home");
  };

  const generateCaptcha = () => {
    const captchaImage = new Captcha(
      "35px IranSans",
      "center",
      "middle",
      150,
      50,
      "#eee",
      "#111",
      6
    ).createImage();

    function createMarkup(source) {
      return { __html: source };
    }

    function MyCaptcha() {
      return <div dangerouslySetInnerHTML={createMarkup(captchaImage)} />;
    }

    let randomWord = captchaImage.split("data-key")[1].split('"')[1];

    setRandomCaptcha({ image: <MyCaptcha />, word: randomWord });
    setLoading(false);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);
  return (
    <>
      {loading && <LoadingCM />}
      <Wrapper>
        <StyledStack spacing={10} p={{ sm: 3, xs: 3 }}>
          <ImgContainer
            src={logo}
            alt="لوگو"
            objectFit="contain"
            width="200px"
            style={{ marginTop: "10px" }}
          />
          <FormControl style={{ marginTop: "40px" }}>
            <Stack spacing={2} justifyContent="center" alignItems="center">
              <TextField
                id="username"
                label="نام کاربری"
                variant="outlined"
                fullWidth
                {...name}
                size="small"
              />
              <TextField
                id="password"
                label="رمز عبور"
                variant="outlined"
                fullWidth
                size="small"
                {...password}
                type={toggle.passwordVisibility ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleChange}
                        // onMouseDown={handleMouseDownPassword}
                      >
                        {toggle.passwordVisibility && <Visibility />}
                        {!toggle.passwordVisibility && <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Stack
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <TextField
                  id="captcha"
                  label="کد امنیتی"
                  variant="outlined"
                  sx={{ width: "65%" }}
                  {...captcha}
                  size="small"
                />
                <StyledBoxContainer item>
                  <StyledBox>{randomCaptcha.image}</StyledBox>

                  <MdRefresh
                    size={22}
                    onClick={generateCaptcha}
                    style={{ marginTop: "10px" }}
                  />
                </StyledBoxContainer>
              </Stack>
              <Button variant="contained" onClick={handleSubmit} fullWidth>
                ورود
              </Button>
            </Stack>
          </FormControl>
        </StyledStack>
        <StyledImgContainer src={logo} alt="لوگو" objectFit="contain" />
      </Wrapper>
    </>
  );
}
